export const Kirim = [
  {
    id: 1,
    name: "Reguler",
    harga: 10.000,
    estimasi: "3 hari",
  },
  {
    id: 2,
    name: "Ekonomi",
    harga: 7.000,
    estimasi: "5 hari",
  },
  {
    id: 3,
    name: "Kargo",
    harga: 4.000,
    estimasi: "7 hari",
  },
  
]